<template>
  <div class="applyForm">
    <Modal class="auditPop" title="查看报名表信息" v-model="addApplyModal" fullscreen footer-hide @on-visible-change="resetForm('addApplyForm')">
      <Form ref="addApplyForm" :model="addApplyForm" :label-width="170" inline label-colon disabled>
        <FormItem label="本人登记照" style="width: 100%">
          <div class="demo-upload-list" v-if="fileData.url">
            <img :src="fileData.url">
          </div>
          <Upload v-else class="upload" ref="photo" v-model="addApplyForm.photo" type="select" :action="uploadUrl"
            :format="['jpg', 'jpeg', 'png']" :show-upload-list="false">
            <!-- :default-file-list="defaultList" -->
            <div class="icon-box cur">
              <Icon class="icon" type="ios-camera" size="26"></Icon>
            </div>
            <div slot="tip" class="inline tip">请上传jpg, jpeg, png格式的图片, 建议图片大小不超过1M</div>
          </Upload>
        </FormItem>
        <Row :gutter="16">
          <Col span="6">
          <FormItem label="姓名" class="con">
            <Input v-model="addApplyForm.name" placeholder="请输入姓名" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="性别" class="con" required>
            <RadioGroup v-model="addApplyForm.gender">
              <Radio class="sexRedio" v-for='(item,i) in genderList' :key="i" :label='item.dictValue' :value='item.dictLabel'></Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="身份证号" prop="idNumber" class="con">
            <Input v-model="addApplyForm.idNumber" placeholder="请输入身份证号" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="联系电话" prop="tel" class="con">
            <Input v-model="addApplyForm.tel" placeholder="请输入手机号" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="最高学历" prop="highestDegree" class="con">
            <Select v-model="addApplyForm.highestDegree" placeholder="请选择最高学历" clearable>
              <Option v-for="(item,i) in degreeList" :value="item.dictValue" :key="i">{{ item.dictLabel }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="毕业日期" prop="graduationDate" class="con">
            <DatePicker type="date" :value="addApplyForm.graduationDate" :options="finishTime" placement="bottom-end" placeholder="请选择毕业日期"
              format='yyyy-MM-dd'></DatePicker>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="工作年限" prop="workingYears" class="con">
            <Input type="number" v-model="addApplyForm.workingYears" placeholder="单位默认为年" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="所学专业" prop="major" class="con">
            <Input v-model="addApplyForm.major" placeholder="请输入所学专业" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="专业工作年限" prop="majorWorkYears" class="con">
            <Input type="number" v-model="addApplyForm.majorWorkYears" placeholder="单位默认为年" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="现任专业职务" prop="majorJob" class="con">
            <Select v-model="addApplyForm.majorJob" placeholder="请选择现任专业职务" clearable>
              <Option v-for="(item,i) in jobList" :value="item.dictValue" :key="i">{{ item.dictLabel }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="现任专业职务级别" prop="majorJobTitle" class="con">
            <Select v-model="addApplyForm.majorJobTitle" placeholder="请选择现任专业职务级别" clearable>
              <Option v-for="(item,i) in titleList" :value="item.dictValue" :key="i">{{ item.dictLabel }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="任现职日期" prop="jobDate" class="con">
            <DatePicker type="date" :value="addApplyForm.jobDate" :options="finishTime" placement="bottom-end" placeholder="请选择任现职日期"
              format='yyyy-MM-dd'></DatePicker>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="工作单位" prop="unitName" class="con">
            <Input v-model="addApplyForm.unitName" placeholder="请输入工作单位" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="存档单位" prop="archivesUnit" class="con">
            <Input v-model="addApplyForm.archivesUnit" placeholder="请输入存档单位" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="邮政编码" prop="postCode" class="con">
            <Input type="number" v-model="addApplyForm.postCode" placeholder="请输入邮政编码" clearable></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="测试专业名称" prop="examMajor" class="con">
            <Select v-model="addApplyForm.examMajor" placeholder="请选择测试专业名称" clearable>
              <Option v-for="(item,i) in specialList" :value="item.dictValue" :key="i">{{ item.dictLabel }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="测试级别" prop="examMajorTitle" class="con">
            <Select v-model="addApplyForm.examMajorTitle" placeholder="请选择测试级别" clearable>
              <Option v-for="(item,i) in levelList" :value="item.dictValue" :key="i">{{ item.dictLabel }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="通讯地址" prop="address" class="con">
            <Input v-model="addApplyForm.address" placeholder="请输入通讯地址" clearable></Input>
          </FormItem>
          </Col>
          <Divider orientation="left" class="cross">上传资料</Divider>
          <Col span="8">
          <FormItem label="身份证人像面" prop="idcardHead" class="con card">
            <vue-viewer class="front inline" :thumb="frontData.url" :full="frontData.url" v-if="frontData.url">
              <img :src="frontData.url">
            </vue-viewer>
            <Upload v-else ref="idcardHead" v-model="addApplyForm.idcardHead" :headers="uploadData" :action="uploadUrl" type="select"
              :format="['jpg', 'jpeg', 'png']" :max-size="2048" :show-upload-list="false">
              <div class="front-box cur">
                <Icon class="icon" type="md-add" size="26"></Icon>
              </div>
            </Upload>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="身份证国徽面" class="con card" prop="idcardNationalEmblem">
            <vue-viewer class="front inline" :thumb="backData.url" :full="backData.url" v-if="backData.url">
              <img :src="backData.url">
            </vue-viewer>
            <Upload v-else ref="idcardNationalEmblem" v-model="addApplyForm.idcardNationalEmblem" :headers="uploadData" :action="uploadUrl"
              type="select" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :show-upload-list="false">
              <div class="front-box cur">
                <Icon class="icon" type="md-add" size="26"></Icon>
              </div>
            </Upload>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="职称证书" class="con card" prop="titleCertificate">
            <vue-viewer class="front inline" :thumb="bookData.url" :full="bookData.url" v-if="bookData.url">
              <img :src="bookData.url">
            </vue-viewer>
            <Upload v-else ref="titleCertificate" v-model="addApplyForm.titleCertificate" :headers="uploadData" :action="uploadUrl"
              type="select" :format="['jpg', 'jpeg', 'png']" :max-size="2048" :show-upload-list="false">
              <div class="front-box cur">
                <Icon class="icon" type="md-add" size="26"></Icon>
              </div>
            </Upload>
          </FormItem>
          </Col>
          <Col span="20">
          <FormItem label="盖章报名表" class="con card registion" prop='registion'>
            <vue-viewer class="front inline" :thumb="registionData.url" :full="registionData.url" v-if="registionData.url">
              <img :src="registionData.url">
            </vue-viewer>
            <Upload v-else ref="registion" v-model="addApplyForm.registion" :headers="uploadData" :action="uploadUrl" type="select"
              :format="['jpg', 'jpeg', 'png']" :max-size="2048" :show-upload-list="false">
              <div class="front-box cur">
                <Icon class="icon" type="md-add" size="26"></Icon>
              </div>
              <div slot="tip" class="applyTip">将打印出的报名表,盖上单位公章后拍照上传</div>
            </Upload>
          </FormItem>
          </Col>
        </Row>
        <FormItem class="bot">
          <Button type="primary" style="margin-right: 20px" @click="submit('addApplyForm')">确定</Button>
          <Button type="primary" @click="addApplyModal = false" ghost>取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { bizURL } from "@/config/baseUrl";

export default {
  data() {
    return {
      addApplyModal: false,
      uploadUrl: bizURL + "/registration/registration/upload",
      uploadData: { Authorization: sessionStorage.getItem("token") },
      defaultList: [],
      imgName: "",
      visible: false,
      uploadList: [],
      fileData: {},
      frontData: {}, // 身份证人像面
      backData: {}, // 身份证国徽面
      bookData: {}, // 职称证书
      registionData: {}, // 盖章报名表
      genderList: JSON.parse(sessionStorage.getItem("genderList")), // 性别
      degreeList: JSON.parse(sessionStorage.getItem("degreeList")), // 最高学历
      specialList: JSON.parse(sessionStorage.getItem("specialList")), // 测试专业名称
      levelList: JSON.parse(sessionStorage.getItem("levelList")), // 测试专业级别
      jobList: JSON.parse(sessionStorage.getItem("jobList")), // 现任专业职务
      titleList: JSON.parse(sessionStorage.getItem("titleList")), // 现任专业职务级别
      stateList: [
        { value: "100", label: "待审核" },
        { value: "200", label: "审核通过" },
        { value: "150", label: "审核不通过" },
      ],
      addApplyForm: {
        photo: "",
        name: "",
        gender: "男",
        idNumber: "",
        tel: "",
        highestDegree: "",
        graduationDate: "",
        workingYears: "",
        major: "",
        majorWorkYears: "",
        majorJob: "",
        majorJobTitle: "",
        jobDate: "",
        unitName: "",
        archivesUnit: "",
        postCode: "",
        examMajor: "",
        examMajorTitle: "",
        address: "",
        idcardHead: "", //身份证头像面
        idcardNationalEmblem: "", //身份证国徽面
        registion: "", //盖章报名表
        titleCertificate: "", //职称证书表
      },
      addApplyRule: {
        photo: [
          {
            required: true,
            message: "本人证件照为必填",
            trigger: "change",
            // validator: (rule, value, callback) => {
            //   if (!value) {
            //     return callback(new Error('本人证件照为必填'));
            //   } else {
            //     callback();
            //   }
            // }
          },
        ],
        name: [{ required: true, message: "姓名为必填", trigger: "change" }],
        idNumber: [
          { required: true, message: "身份证号为必填", trigger: "change" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|x|X)$)/,
            message: "证件号码格式有误！",
            trigger: "change",
          },
        ],
        tel: [
          { required: true, message: "联系电话为必填", trigger: "change" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "change",
          },
        ],
        highestDegree: [
          { required: true, message: "最高学历为必填", trigger: "change" },
        ],
        graduationDate: [
          { required: true, message: "毕业时间为必填", trigger: "change" },
        ],
        workingYears: [
          { required: true, message: "工作年限为必填", trigger: "change" },
        ],
        major: [
          { required: true, message: "所学专业为必填", trigger: "change" },
        ],
        majorWorkYears: [
          { required: true, message: "专业工作年限为必填", trigger: "change" },
        ],
        majorJob: [
          { required: true, message: "现任专业职务为必填", trigger: "change" },
        ],
        majorJobTitle: [
          {
            required: true,
            message: "现任专业职务级别为必填",
            trigger: "change",
          },
        ],
        jobDate: [
          { required: true, message: "任现职时间为必填", trigger: "change" },
        ],
        unitName: [
          { required: true, message: "工作单位为必填", trigger: "change" },
        ],
        archivesUnit: [
          { required: true, message: "存档单位为必填", trigger: "change" },
        ],
        postCode: [
          { required: true, message: "邮政编码为必填", trigger: "change" },
        ],
        examMajor: [
          { required: true, message: "测试专业名称为必填", trigger: "change" },
        ],
        examMajorTitle: [
          { required: true, message: "测试级别为必填", trigger: "change" },
        ],
        address: [
          { required: true, message: "通讯地址为必填", trigger: "change" },
        ],
        idcardHead: [
          { required: true, message: "身份证头像面为必填", trigger: "change" },
        ],
        idcardNationalEmblem: [
          { required: true, message: "身份证国徽面为必填", trigger: "change" },
        ],
        titleCertificate: [
          { required: true, message: "职称证书表为必填", trigger: "change" },
        ],
      },
       finishTime: {
        shortcuts: [
          {
            text: "今天",
            value() {
              return new Date();
            },
          },
          {
            text: "昨天",
            value() {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              return date;
            },
          },
          {
            text: "一周前",
            value() {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              return date;
            },
          },
        ]
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
</style>